import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule} from './shared/material/material.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FlexLayoutModule } from '@angular/flex-layout';
import { IwgcommonModule } from './iwgcommon/iwgcommon.module';
import { UserService } from './shared/services/user.service';
import { StatsService } from './shared/services/stats.service';
import { Utils } from './shared/utils/utils';
import { HttpConfigInterceptor } from './interceptor/httpconfig.interceptor';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatPaginatorIntlCro } from './iwgcommon/list/CustomPaginator';
import { MAT_SELECT_SCROLL_STRATEGY } from '@angular/material/select';
import { Overlay, BlockScrollStrategy } from '@angular/cdk/overlay';
import { BaseService } from './shared/services';
import { SharedPipesModule } from './shared/pipes/sharedpipes.module';
import {QuoteEstimatorModule} from './quote-estimator/quote-estimator.module';
import {VendorInvoiceService} from './shared/services/vendor-invoice.service';
import { AuthGuard } from './shared/guard/auth.guard';
import { CountryGuidesModule } from './country-guides/country-guides.module';
import {DocumentsModule} from './documents/documents.module';
import {WorkerProfileModule} from '../app/worker-profile/worker-profile.module';
import { CsvDataService } from './shared/services/csv-export.service';
import { IWGSharedService } from './shared/services/shared.service';
import {MyTalentRateModule} from './my-talent-rate/my-talent-rate.module';
import {MyTalentSearchModule} from './my-talent-search/my-talent-search.module';
import {ContactInfoModule} from '../app/contact-info/contact-info.module';
import { CommonModule, CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { PercentagePipe } from './shared/pipes/percentage.pipe';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from "ng-recaptcha";
export function scrollFactory(overlay: Overlay): () => BlockScrollStrategy {
  return () => overlay.scrollStrategies.block();
}
@NgModule({
  declarations: [
    AppComponent,
     ],
  imports: [

    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    MaterialModule,
    HttpClientModule,
    IwgcommonModule,
    SharedPipesModule,
    QuoteEstimatorModule,
    CountryGuidesModule,
    DocumentsModule,
    WorkerProfileModule,
    MyTalentRateModule,
    MyTalentSearchModule,
    ContactInfoModule,
    RecaptchaV3Module,
    CommonModule
  ],
  providers: [UserService, StatsService, Utils, BaseService, VendorInvoiceService, AuthGuard, IWGSharedService, 
    CsvDataService, DatePipe, CurrencyPipe, PercentagePipe, DecimalPipe,
    { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true },
    {
      provide: MatPaginatorIntl,
      useClass: MatPaginatorIntlCro
    },
    { provide: MAT_SELECT_SCROLL_STRATEGY, useFactory: scrollFactory, deps: [Overlay] },
    { provide: LOCALE_ID, useValue: 'en-US'}
    ,{ provide: RECAPTCHA_V3_SITE_KEY, useValue: "6Ld8XSYaAAAAAJU-WW_L1NZS4vFAWHGJdqHBLk3w" }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
  exports: []
})
export class AppModule { }
